/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { MainDownloadCode } from '../config/app-config';

export const layoutOptions = [
  {
    code: MainDownloadCode.CTL,
    name: 'SDG Impact',
  },
  {
    code: MainDownloadCode.SGX_Metrics,
    name: 'SGX metrics',
  },
] as const
